// pages/FeteENG.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function SpectacleENG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fete-page">

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .fete-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .fete-page h1 {
            font-size: 2.5rem !important;
          }
          .fete-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset10.png"
        alt="Expressions Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        direction: 'ltr'
      }}>
        Expressions of Rights
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '30px',
        fontWeight: '600',
        lineHeight: '1.6',
        direction: 'ltr'
      }}>
        Artistic and creative performances celebrating rights and freedoms
      </h3>

      {/* Event Info */}
      <div style={{
        background: 'var(--secondary-black)',
        padding: '20px 30px',
        borderRadius: '15px',
        borderLeft: '4px solid var(--primary-orange)',
        marginTop: '30px',
        direction: 'ltr',
        textAlign: 'center'
      }}>
        <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
          <img src="/images/calandarv.png" className="tab-icon3-img" alt="Calendar" /> <strong>Date:</strong> December 10, 2025
        </p>
        <p style={{ fontSize: '1.3rem' }}>
          <img src="/images/location.png" className="tab-icon3-img" alt="Location" /> <strong>Location:</strong> Venue to be set soon
        </p>
      </div>

      </div>
    </div>

      {/* Main Content Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">

          {/* Introduction */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              For the effectiveness of rights
            </h3>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              borderLeft: '5px solid var(--primary-orange)',
              marginBottom: '40px',
              textAlign: 'left'
            }}>
              <p style={{
                fontSize: '1.15rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                marginBottom: '20px',
                textAlign: 'left'
              }}>
                "Expressions of rights" is an annual celebration of rights-related artistic and creative expression. This year, it marks the culmination of the National Campaign to End Digital Violence Against Women and Girls (November 25 – December 10).
              </p>

              <p style={{
                fontSize: '1.15rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                marginBottom: '20px',
                textAlign: 'left'
              }}>
                A closing ceremony in an open space, embracing and welcoming all expressions of rights.
              </p>

              <p style={{
                fontSize: '1.15rem',
                lineHeight: '2',
                color: 'var(--text-light)',
                textAlign: 'left'
              }}>
                Art, in all its forms and expressions, is more than an aesthetic or creative act. It is a force that advances rights and freedoms, challenges violence, and opens up new horizons for reflection and awareness.
              </p>
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Join this celebration
            </h3>

            <p style={{
              fontSize: '1.2rem',
              lineHeight: '1.8',
              color: 'var(--text-light)',
              marginBottom: '30px',
              direction: 'ltr'
            }}>
              Be part of this historical event and contribute to shaping a violence-free world.
            </p>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic',
              direction: 'ltr'
            }}>
              Together we express rights | Together we build the future
            </p>
          </div>
        </div>
      </div>

      <Carousel />
    </div>
  );
}

export default SpectacleENG;
